var exports = {
  "M": "FormControl__nBBPrA",
  "a": "Box__c1ps__",
};

module.exports = exports;
